import createNumberMask from './createNumberMask';

const numberMask = createNumberMask({
  allowDecimal: true,
  prefix: '',
  thousandsSeparatorSymbol: ' ',
  decimalLimit: 0,
});

export default numberMask;